import React from 'react';
import './BacklotMenu.css';
import Home from './components/home/Home';

export function BacklotMenu() {
  return <Home></Home>;
}
